<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar área" : "Nueva área" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos de la área' : 'Datos de la nueva área'">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full mb-3 px-2">
            <wz-input
              label="Descripción"
              required
              v-model="form.description"
              placeholder="Descripción"
              :error="$v.form.description.$error && !$v.form.description.required ? 'Descripción es requerida' : ''"
            />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button variant="light" @click="$router.push({ name: 'area-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>

    <!-- CDEF010: campos personalizados de la entidad (solo en edición) -->
    <wz-card v-if="editing && $route.params.id" class="mt-3">
      <custom-fields-section entity="AREA" :entity-id="Number($route.params.id)" />
    </wz-card>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { AreaService } from '@/core/services'
import { required } from 'vuelidate/lib/validators'
import CustomFieldsSection from '@/core/components/CustomFieldsSection.vue'

export default {
  components: { CustomFieldsSection },
  data() {
    return { loading: true, editing: false, form: { description: null } }
  },
  validations: { form: { description: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) return
      try {
        this.$store.dispatch('app/loading', true)
        let response
        if (!this.editing) response = await AreaService.save({ ...this.form })
        else response = await AreaService.update(this.$route.params.id, { ...this.form })
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) { this.$router.push({ name: 'area-edit', params: { id: response.payload.id } }); this.editing = true }
      } catch (ex) { console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar') }
      finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const payload = (await AreaService.get(id)).payload
        this.form = { ...payload }
        this.editing = true
      } catch (e) { console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar'); this.$router.push({ name: 'area-list' }) }
      finally { this.$store.dispatch('app/loading', false); setTimeout(() => { this.loading = false }, 1000) }
    },
  },
  async created() { if (this.$route.params.id) this.load(this.$route.params.id); else this.loading = false },
}
</script>
